'use client';

import Image from 'next/image';
import type * as React from 'react';

const LOGO_SIZE = 72;

export function LoginLogo(): React.ReactNode {
  return (
    <div className="relative inline-flex items-center justify-center rounded-lg mb-2">
      <Image
        src="/logo/svg/coolmate-logo.svg"
        alt="Cool Mate"
        width={LOGO_SIZE}
        height={LOGO_SIZE}
        className="relative z-10 rounded-lg"
      />
    </div>
  );
}
